export default "__VITE_ASSET__DG1bvS85__"